var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"text-center"},[_c('amplify-authenticator',[_c('amplify-sign-in',{attrs:{"slot":"sign-in","hide-sign-up":"true"},slot:"sign-in"}),_c('amplify-sign-up',{attrs:{"slot":"sign-up","hide-sign-up":"true"},domProps:{"formFields":_vm.formFields},slot:"sign-up"})],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }